import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { ROLES } from '../utils/roleUtils';

function RoleBasedRoute({ children, allowedRoles = [], redirectTo = null }) {
  const { userProfile } = useAuth();
  const { userId } = useParams();

  // If no user profile yet, show loading
  if (!userProfile) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#888'
      }}>
        Loading user profile...
      </div>
    );
  }

  const userRole = userProfile.role;

  // Check if user has required role
  if (!allowedRoles.includes(userRole)) {
    // Redirect based on user role to their default section
    const defaultRoute = getDefaultRouteForRole(userRole, userId);
    return <Navigate to={redirectTo || defaultRoute} replace />;
  }

  return children;
}

// Helper function to get default route based on user role
function getDefaultRouteForRole(role, userId) {
  switch (role) {
    case ROLES.ADMIN:
      return `/app/${userId}/analytics`;
    case ROLES.TEAM_LEAD:
      return `/app/${userId}/analytics`;
    case ROLES.AGENT:
      return `/app/${userId}/dialer`;
    default:
      return '/login';
  }
}

export default RoleBasedRoute;
export { getDefaultRouteForRole }; 